import { render, staticRenderFns } from "./DineInStoreManagement.vue?vue&type=template&id=08baa4cf&scoped=true"
import script from "./DineInStoreManagement.vue?vue&type=script&lang=js"
export * from "./DineInStoreManagement.vue?vue&type=script&lang=js"
import style0 from "./DineInStoreManagement.vue?vue&type=style&index=0&id=08baa4cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08baa4cf",
  null
  
)

export default component.exports